<template>
  <section class="home-block">
    <div ref="content" class="content">
      <div class="container">
        <div ref="title" class="title h1">
          Проекты компании в Москве <br />
          <span>и Московской области</span>
        </div>
      </div>
      <CompanyProjectMap />
    </div>
  </section>
</template>

<script>
import { gsap } from "gsap";
import { is_touch } from "@/helpers.js";
import CompanyProjectMap from "@/components/home/CompanyProjectMap.vue";
export default {
  components: {
    CompanyProjectMap,
  },
  computed: {},
  mounted() {
    if (!is_touch()) {
      gsap.from(gsap.utils.toArray([this.$refs.title]), {
        y: 150,
        stagger: { each: 0.1 },
        scrollTrigger: {
          trigger: this.$refs.content,
          start: "top bottom",
          end: "70% center",
          scrub: 1.5,
        },
      });
    }
  },
};
</script>

<style scoped>
.content {
  max-width: 100%;
}

.title {
  position: relative;
  z-index: 2;
  margin-bottom: 57px;
  text-align: center;
}

.h1 {
  font-size: 72px;
}

@media (max-width: 767px) {
  .title {
    margin-bottom: 27px;
  }

  .h1 {
    font-size: 48px;
  }

  span {
    font-weight: 500;
    font-size: 24px;
  }
}
</style>
